import { createSlice } from "@reduxjs/toolkit";
import _dropRight from 'lodash/dropRight';
import _find from 'lodash/find';
import _map from 'lodash/map';
import _unionBy from 'lodash/unionBy';
import { 
  getFifthAnalyses, 
  getFifthAnalysis,
  clearLocalFifthAnalyses,
  clearLocalActiveFifthAnalysis 
} from "./actions";

export const initialState = {
  all: { 
    data: [], 
    pagination: { limit: 25, offset: 0, count: 0, total_count: 0 } 
  },
  fifthAnalysis: { 
    id: '', 
    input: '', 
    result: '', 
    status: '', 
    updated_at: '' 
  },
  loading: { 
    all: false, 
    fifthAnalysis: false 
  }
};

const slice = createSlice({
  name: 'fifthAnalyses',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getFifthAnalyses.pending, (state) => {
        state.loading.all = true;
      })
      .addCase(getFifthAnalyses.fulfilled, (state, action) => {
        const { fifth_analyses, pagination } = action.payload;
        const newData = _unionBy([...state.all.data, ...fifth_analyses], 'id');
        
        state.loading.all = false;
        state.all.data = newData;
        state.all.pagination = pagination;
      })
      .addCase(getFifthAnalyses.rejected, (state) => {
        state.loading.all = false;
      })
      .addCase(getFifthAnalysis.pending, (state) => {
        state.loading.fifthAnalysis = true;
      })
      .addCase(getFifthAnalysis.fulfilled, (state, action) => {
        const { data: { fifth_analysis }, cable } = action.payload;
        const foundedFifthAnalysis = !!_find(state.all.data, (s) => s.id === fifth_analysis.id);
        const updatedFifthAnalysis = { ...state.fifthAnalysis, ...fifth_analysis };
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = foundedFifthAnalysis ? _map(state.all.data, (e) => e.id === fifth_analysis.id ? { ...e, ...fifth_analysis } : e) : [...[fifth_analysis], ...oldAllData]; 
        const pagination = foundedFifthAnalysis ? state.all.pagination : { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.fifthAnalysis = false;
        state.all.data = data; 
        state.all.pagination = pagination;
        if (foundedFifthAnalysis && !cable) state.fifthAnalysis = updatedFifthAnalysis;       
      })
      .addCase(getFifthAnalysis.rejected, (state) => {
        state.loading.fifthAnalysis = false;
      })
      .addCase(clearLocalFifthAnalyses, state => {
        state.all = initialState.all;
      })
      .addCase(clearLocalActiveFifthAnalysis, state => {
        state.fifthAnalysis = initialState.fifthAnalysis;
      })
  }
})

export default slice.reducer;